import React from 'react';
import PortfolioRebalance from '../features/portfolios/rebalance/portfolio-rebalance';

function PortfoliosRebalancePage() {
  return (
    <div className='flex flex-col lg:flex-row w-full overflow-y-auto'>

      <div className='flex grow overflow-y-auto'>
        <PortfolioRebalance />
      </div>

    </div>
  );
}

export default PortfoliosRebalancePage;
